let refreshPromise = null;

export const refreshAccessTokenOnce = (refresh) => {
  if (!refreshPromise) {
    refreshPromise = Promise.resolve()
      .then(() => refresh())
      .finally(() => {
        refreshPromise = null;
      });
  }

  return refreshPromise;
};
